import React, { useState, useEffect } from 'react';
import { Container, Alert } from 'react-bootstrap';
import api from '../services/api';
import './EmergencyAlerts.css';

const EmergencyAlerts = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    loadAlerts();
  }, []);

  const loadAlerts = async () => {
    try {
      const response = await api.get('/emergency-alerts/');
      setAlerts(response.data.filter(alert => alert.show_on_homepage));
    } catch (error) {
      console.error('Error loading alerts:', error);
    }
  };

  if (alerts.length === 0) return null;

  return (
    <div className="emergency-alerts">
      <Container>
        {alerts.map(alert => (
          <Alert key={alert.id} variant={alert.alert_type} className="mb-2">
            <Alert.Heading>{alert.title}</Alert.Heading>
            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
          </Alert>
        ))}
      </Container>
    </div>
  );
};

export default EmergencyAlerts;
